import {prefixPath} from "@pg-mono/prefix-path";

import {BIG_DATA_API_PREFIX} from "./api_prefixes";

const RP_API_SCOPE_PREFIX = "rp";

export const apiPath = prefixPath(BIG_DATA_API_PREFIX, {
    currentDate: prefixPath("current-date/", {
        base: ""
    }),
    monthCityStats: prefixPath(`${RP_API_SCOPE_PREFIX}/month-city-stats/`, {
        base: ""
    }),
    monthCityTypeStats: prefixPath(`${RP_API_SCOPE_PREFIX}/month-city-type-stats/`, {
        base: ""
    }),
    monthDistrictStats: prefixPath(`${RP_API_SCOPE_PREFIX}/month-district-stats/`, {
        base: ""
    }),
    monthDistrictTypeStats: prefixPath(`${RP_API_SCOPE_PREFIX}/month-district-type-stats/`, {
        base: ""
    })
});

export const apiBigDataLink = {
    currentDate: {
        base: createLinkBd(apiPath.currentDate.base)
    },
    monthCityStats: {
        base: createLinkBd(apiPath.monthCityStats.base)
    },
    monthCityTypeStats: {
        base: createLinkBd(apiPath.monthCityTypeStats.base)
    },
    monthDistrictsStats: {
        base: createLinkBd(apiPath.monthDistrictStats.base)
    },
    monthDistrictTypeStats: {
        base: createLinkBd(apiPath.monthDistrictTypeStats.base)
    }
};

function createLinkBd(apiPathElement: string): (bigDataApiPath: string | null) => string {
    return (bigDataApiPath: string | null) => {
        if (bigDataApiPath) {
            return `${bigDataApiPath}${apiPathElement}`;
        }
        throw new Error("BigData API url not defined");
    };
}
import {prefixPath} from "@pg-mono/prefix-path";

import {BIG_DATA_API_PREFIX} from "./api_prefixes";

const RP_API_SCOPE_PREFIX = "rp";

export const apiPath = prefixPath(BIG_DATA_API_PREFIX, {
    currentDate: prefixPath("current-date/", {
        base: ""
    }),
    monthCityStats: prefixPath(`${RP_API_SCOPE_PREFIX}/month-city-stats/`, {
        base: ""
    }),
    monthCityTypeStats: prefixPath(`${RP_API_SCOPE_PREFIX}/month-city-type-stats/`, {
        base: ""
    }),
    monthDistrictStats: prefixPath(`${RP_API_SCOPE_PREFIX}/month-district-stats/`, {
        base: ""
    }),
    monthDistrictTypeStats: prefixPath(`${RP_API_SCOPE_PREFIX}/month-district-type-stats/`, {
        base: ""
    })
});

export const apiBigDataLink = {
    currentDate: {
        base: createLinkBd(apiPath.currentDate.base)
    },
    monthCityStats: {
        base: createLinkBd(apiPath.monthCityStats.base)
    },
    monthCityTypeStats: {
        base: createLinkBd(apiPath.monthCityTypeStats.base)
    },
    monthDistrictsStats: {
        base: createLinkBd(apiPath.monthDistrictStats.base)
    },
    monthDistrictTypeStats: {
        base: createLinkBd(apiPath.monthDistrictTypeStats.base)
    }
};

function createLinkBd(apiPathElement: string): (bigDataApiPath: string | null) => string {
    return (bigDataApiPath: string | null) => {
        if (bigDataApiPath) {
            return `${bigDataApiPath}${apiPathElement}`;
        }
        throw new Error("BigData API url not defined");
    };
}
